import { createStyle } from '@gluestack-style/react';

export const ButtonText = createStyle({
  color: '$textLight0',
  _web: {
    userSelect: 'none',
  },
});
